module.exports = __webpack_public_path__ + "static/media/done_venice.d4f06bf5.png";